import * as React from 'react';
import { useSelector } from '@grandvisionhq/state';
import '../../../../models/cart/cart-state.js';
import '../../../../models/checkout/checkout-step-error-type.js';
import '../../../../models/checkout-settings.js';
import { ShippingMethod } from '../../../../models/step-shipping/shipping-methods.js';
import '../../../../models/shared.js';
import { getSelectedShippingMethod } from '../../../selectors.js';
import { PickupPointsContainer } from './PickupPointsContainer.js';
import { PickupStoresContainer } from './PickupStoresContainer.js';

const SelectedShippingMethodContainer = ({ warningMessageOnly =false , hideTitle =false  })=>{
    var ref;
    const selectedShippingMethod = (ref = useSelector(getSelectedShippingMethod)) === null || ref === void 0 ? void 0 : ref.method;
    switch(selectedShippingMethod){
        case ShippingMethod.Pickup:
            return /*#__PURE__*/ React.createElement(PickupStoresContainer, {
                hideTitle: hideTitle,
                warningMessageOnly: warningMessageOnly
            });
        case ShippingMethod.PickupPoint:
            return /*#__PURE__*/ React.createElement(PickupPointsContainer, {
                hideTitle: hideTitle,
                warningMessageOnly: warningMessageOnly
            });
        default:
            return null;
    }
};

export { SelectedShippingMethodContainer };
//# sourceMappingURL=SelectedShippingMethodContainer.js.map
